import { useActive, useChainedCommands, useCommands, useRemirrorContext } from "@remirror/react";
import React, { useEffect, useRef, useState, MutableRefObject } from "react";
import "./BlockTypeDropdown.css";
type BlockTypeDropdownProps = {};



const CodeTypeDropdown: React.FC<BlockTypeDropdownProps> = () => {
    const active = useActive();
    const languages = ["kotlin", "dart" , "swift", "js", "ts", "html", "xml", "css", "json"]
    const activeLanguage = () => {
        let activeHeading = "code"
        languages.forEach((level) => {
            if (active.codeBlock({ language: level })) {
                activeHeading = level;
            }
        });
        return activeHeading;
    };
    const commands = useChainedCommands() as any;
    const handler = (language: string) => {
        
            commands.toggleCodeBlock({ language: language }).focus().run();
        }
    



    return (
        <div className="gigauser-texteditor-toolbar-blocktype-dropdown" >
            <div className="gigauser-texteditor-toolbar-blocktype-dropdown-heading">
                {activeLanguage()}
            </div>

            <div className="gigauser-texteditor-toolbar-blocktype-dropdown-content">
                {languages.map(language=><div
                    className={`gigauser-texteditor-toolbar-blocktype-dropdown-content-item`}
                    onMouseDown={(e) => {
                        e.preventDefault();
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        handler(language);
                    }}
                >
                    {language}
                </div>)}
            </div>
        </div>
    );
};
export default CodeTypeDropdown;
